import {
  Avatar,
  Card,
  CardContent,
  CardHeader,
  Divider,
  List,
} from "@mui/material";
import { red } from "@mui/material/colors";
import { ListFilesOptions } from "components/componentesGenerales/uploadFilesComponent/listFilesOptions";
import { VisorDocumentos } from "components/componentesGenerales/visorDocumentos/visorDocumentos";
import { useSolicitudesFirmaStore } from "hooks/useSolicitudesFirmaStore";
import { useVisorDocumentosStore } from "hooks/useVisorDocumentosStore";
import { FileArgs } from "interfaces/serviciosGenerales/serviciosGeneralesInterface";

export const DocumentosSolicitudFirma = () => {
  const { solicitudFirma, startGetFile, openModalVisor } =
    useSolicitudesFirmaStore();
  const { documentSelected, openVisor } = useVisorDocumentosStore();

  const listFiles = solicitudFirma?.demanda?.archivos
    ? Object.values(solicitudFirma?.demanda?.archivos!)
        .filter((file) => file.digestion)
        .map((archivo) => {
          let body = {
            ...archivo,
            size: (Number(archivo.size.split(" ")[0]) / 1000000).toFixed(2),
          };

          return body;
        })
    : solicitudFirma?.promocion?.archivos
    ? Object.values(solicitudFirma?.promocion?.archivos!)
        .filter((file: any) => file.digestion)
        .map((archivo: any) => {
          let body = {
            ...archivo,
            size: (Number(archivo.size.split(" ")[0]) / 1000000).toFixed(2),
          };

          return body;
        })
    : [];

  return (
    <Card
      className="w-full lg:w-[92%] xl:w mx-auto"
      sx={{
        borderRadius: "10px",
        paddingY: "24px",
        boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.2)",
      }}
    >
      <CardHeader
        avatar={
          <Avatar sx={{ bgcolor: red[500] }} aria-label="recipe">
            2
          </Avatar>
        }
        title={
          solicitudFirma?.demanda
            ? "Documentos de la demanda"
            : "Documentos de la promoción"
        }
      />
      <Divider />
      <CardContent sx={{ paddingY: "2%", paddingX: "2%" }}>
        <List dense={true}>
          {listFiles.map((file: FileArgs, index: number) => (
            <ListFilesOptions
              key={index}
              file={file}
              startDeleteFile={() => console.log()}
              openModalVisor={openModalVisor}
              startGetFile={startGetFile}
              disabled={true}
            />
          ))}
        </List>
        {documentSelected.length && openVisor ? <VisorDocumentos /> : null}
      </CardContent>
    </Card>
  );
};
